import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-desactivate-popup',
  templateUrl: './desactivate-popup.component.html',
  styleUrls: ['./desactivate-popup.component.css']
})
export class DesactivatePopupComponent implements OnInit {
  @Input() public visible: boolean;
  @Input() title: string;
  @Input() reason: string;
  @Input() details: string;
  @Input() showDates: boolean = false;
  @Input() mandatoryDates: boolean = true;
  @Input() showDetails: boolean = false;
  @Input() dateStart: Date;
  @Input() dateEnd: Date;
  @Output() onCancel = new EventEmitter();
  @Output() onSave = new EventEmitter();
  @Output() onClosed = new EventEmitter();

  set isEdited(bool: boolean) {}
  get isEdited(): boolean {
    if (this.reason) {
      if (!this.reason.trim()) {
        return false;
      }
      if (this.showDates) {

        if (this.mandatoryDates && (this.dateStart == null || this.dateEnd == null)) {
          return false;
        }

        /*if (this.dateStart) {
          let today = new Date();
          if (this.dateStart && this.dateStart < today) {
            return false;
          }
        }*/

        if (this.dateStart && this.dateEnd && this.dateStart >= this.dateEnd) {
          return false;
        }
      }
      return true;
    }
    return false;
  }

  constructor() {}

  ngOnInit() {
  }

  getHeight() {
    if (this.showDates) {
      return this.showDetails ? 600 : 465;
    } else {
      return 350;
    }
  }

  cancelClicked(): void {
    this.onCancel.emit();
    this.onHidden();
  }

  saveClicked(): void {
    this.onSave.emit();
    this.onHidden();
  }

  onShowing() {
    this.reason = null;
    this.dateStart = null;
    this.dateEnd = null;
  }

  onHidden() {
    this.visible = false;
    this.onClosed.emit();
  }
}
